export default __webpack_public_path__ + "static/logo_02_duze_cropped-b84bdbd592928595979fc87d541678be.png";